import { Component, OnInit } from '@angular/core';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { TranslationService } from '../../services/translation.service';

@Component({
    selector: 'app-activity-page',
    template: `
    <app-section title="Claims"
      ><app-activity [showTitle]="false" class="tw-w-full" [translationRequest]="translationRequest"></app-activity
    ></app-section>
  `,
    styles: [],
    standalone: false
})
export class ActivityPageComponent implements OnInit {
  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });
  
  constructor(
    public translationService: TranslationService,
  ) {}

  loadTranslations(): void {
    this.translationRequest.language = sessionStorage.getItem('languagepreference');
    this.translationService.getTranslation(this.translationRequest);
  }

  ngOnInit(): void {
    this.loadTranslations();
  }
}
